export const Mydata = {
  data() {
    return {
      systemIds: [
        { id: "1", title: "Android" },
        { id: "2", title: "ios" },
        { id: "3", title: "小程序" },
      ],
      timeType: [
        { id: "1", title: "日" },
        { id: "2", title: "周" },
        { id: "3", title: "月" },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      column: [
        {
          label: "应用",
          prop: "app_name_text",
          width: "150px",
          fixed: true,
        },
        {
          label: "版本号",
          prop: "version",
          width: "100px",
          useSlotHeader:true,  // 自定义表头
          desc:"点击版本号可跳转查看此版本审核异常信息"
        },
        {
          label: "时间",
          prop: "date",
          sortable: "custom",
          width: "130px",
        },
        {
          label: "产品功能更新",
          prop: "renew_content",
          width: "200px",
        },
/*         {
          label: "隐私链接",
          prop: "privacy_link",
          width: "200px",
        }, */
        {
          label: "隐私政策链接更新",
          prop: "privacy_link",
          width: "200px",
        },
        {
          label: "会员更新",
          prop: "member_order",
          width: "200px",
        },
        {
          label: "广告更新",
          prop: "member_adv",
          width: "200px",
        },
        {
          label: "中台统计更新",
          prop: "centre_sdk_up",
          width: "200px",
        },
        {
          label: "备注",
          prop: "remarks",
          width: "200px",
        },
        //   {
        //       label:'审核异常平台',
        //       prop:'err_platform_text',
        //       width:'200px'
        //   },
        //   {
        //       label:'违规原因',
        //       prop:'violation_case',
        //       width:'200px'
        //   },
        //   {
        //       label:'原件截图',
        //       prop:'screenshot',
        //       width:'180px'
        //   },
        //   {
        //       label:'违规处罚',
        //       prop:'punish_temp',
        //       width:'200px'
        //   },
        //   {
        //       label:'原件截图',
        //       prop:'screenshotPub',
        //       width:'180px'
        //   },
        {
          label: "产品负责人",
          prop: "product_admin_id_text",
          width: "100px",
        },
        //   {
        //       label:'增长协作者',
        //       prop:'increase_admin_id_text',
        //       width:'100px'
        //   },
        //   {
        //       label:'商业化协作者',
        //       prop:'commerce_admin_id_text',
        //       width:'100px'
        //   },
        {
          label: "操作",
          prop: "option",
          width: "200px",
        },
      ],
    };
  },
};
